import { clickToDialPhoneNumberRegExp } from './regexp.mjs';

export default function getClickToDialPhoneNumber(displayName) {
  const match = clickToDialPhoneNumberRegExp.exec(displayName);
  return match ? match[1] : '';
}
